export default __webpack_public_path__ + "static/globe-left-new-e5043fea2e804a3a5178fce5743d24bc.png";